const buildAggregateTypePrefKey = ({ aggregateType, suffix, }) => (aggregateType + "_" + suffix);
export default buildAggregateTypePrefKey;
